module.exports = __webpack_public_path__ + "img/chr_ts_90_8.5f43b7c1.png";